<template>
  <div>
    <v-app>
      <v-main>
        <v-container fluid>
          <!-- Example of MusePlayer. Content is centred, but the width/height parameters have no effect -->
          <v-row style="min-height: 400px">
            <v-col
              class="justify-center text-center bg-blue lighten-5"
              cols="12"
              sm="2"
              md="3"
              lg="4"
            >
              Left
            </v-col>

            <v-col
              cols="12"
              sm="8"
              md="6"
              lg="4"
              class="d-flex flex-column align-center justify-center"
            >
              <ExerciseHeader :title="exerciseTitle" />
              <NavigationControl @exit="handleExit" @start="handleStart" @next="handleNext" />
            </v-col>

            <v-col
              class="justify-center text-center bg-blue lighten-5"
              cols="12"
              sm="2"
              md="3"
              lg="4"
            >
              Right
            </v-col>
          </v-row>

          <!-- Example of simple embed of the Muse player. The data-width wotks, though the content is not centred -->
          <v-row class="mt-4">
            <v-col
              class="justify-center text-center bg-blue lighten-5"
              xs="0"
              sm="2"
              md="3"
              lg="4"
            >
              Left
            </v-col>
            <v-col xs="12" sm="8" md="6" lg="4">
              <div
                data-width="70%"
                data-video="y8zH87z"
                class="muse-video-player"
              />
            </v-col>
            <v-col
              class="justify-center text-center bg-blue lighten-5"
              xs="0"
              sm="2"
              md="3"
              lg="4"
            >
              Right
            </v-col>
          </v-row>
        </v-container>
      </v-main>
      <v-footer> Trailer </v-footer>
    </v-app>
  </div>
</template>



<script>
import ExerciseHeader from '@/components/newcomponents/ExerciseHeader.vue';
//import InstructionCard from '@/components/newcomponents/InstructionCard.vue';
//import ExerciseMedia from '@/components/newcomponents/ExerciseMedia.vue';
import NavigationControl from '@/components/newcomponents/NavigationControl.vue';
//import ExercisePreview from '@/components/newcomponents/ExercisePreview.vue';

export default {
  components: {
    ExerciseHeader,
//    InstructionCard,
//    ExerciseMedia,
    NavigationControl,
//    ExercisePreview,
  },
  data() {
    return {
      exerciseTitle: 'Marching (1/7) - Warmup',
      instructions: "This is a key warmup exercise...",
      mediaSrc: "path/to/media",
      nextExercise: { title: 'Leg lifts', imageSrc: 'path/to/next/exercise/image' }
    };
  },
  methods: {
    handleExit() {
      console.log("handleExit")
      // handle exit logic
    },
    handleStart() {
      console.log("handleStart")
      // handle start logic
    },
    handleNext() {
      console.log("handleNext")
      // handle next logic
    }
  }
}
</script>

